import { createSlice } from '@reduxjs/toolkit';

const teamSlice = createSlice({
  name: 'team',
  initialState: {
    teams: []
  },
  reducers: {
    setTeams(state, action) {
        if (!action || !action.payload || !action.payload.teams) {
          state.teams = [];
        } else {
          state.teams = action.payload.teams.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) );
        }      
    },
  },
});

export const teamActions = teamSlice.actions;

export default teamSlice;